import React from "react";
import { Header, Icon } from "semantic-ui-react";

const TransferenciasCuentasPrymeraHeader = () => {
  return (
    <>
      <Header as="h2" color="blue">
        <Icon name="users" color="yellow" /> Transferencia a otra cuenta
        Prymera
      </Header>
    </>
  );
};

export default TransferenciasCuentasPrymeraHeader;
